import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runKeywordStrategy(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_keyword_strategy`)
}

export function getKeywordStrategy(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/keyword_strategy`)
}

export function approveKeywordUniverse(pageId, { addedKeywords, removedItemIds, reclassifications } = {}) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_keyword_universe`, {
    added_keywords: addedKeywords,
    removed_item_ids: removedItemIds,
    reclassifications
  })
}

export function updateKeywordStrategyItem(itemId, data) {
  return axios.patch(`/ajax/keyword_strategy_items/${itemId}/update_item`, data)
}

export function approveKeywordCluster(pageId, itemDecisions = {}) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_keyword_cluster`, { item_decisions: itemDecisions })
}
